/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruletypeinvite3Inputs */

const en_dropruletypeinvite3 = /** @type {(inputs: Dropruletypeinvite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite friends`)
};

const de_dropruletypeinvite3 = /** @type {(inputs: Dropruletypeinvite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freunde einladen`)
};

/**
* | output |
* | --- |
* | "Invite friends" |
*
* @param {Dropruletypeinvite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruletypeinvite3 = /** @type {((inputs?: Dropruletypeinvite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruletypeinvite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruletypeinvite3(inputs)
	return de_dropruletypeinvite3(inputs)
});
export { dropruletypeinvite3 as "dropRuleTypeInvite" }